// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2FTRa","content":"layout-module--content--1mHSh"};